class DynamicSearchService {

    /**
     * @param {{s: string, filter: string}} queryObject
     * @param {Number} offset
     * @param {Number} itemsPerPage
     */
    async getResults(url, queryObject, offset, itemsPerPage, preLoadFilterValue) {
        /* Expected format for body */
        // const body = {
        //     query: queryObject.q || '',
        //     filterValues: queryObject.filterValues,
        //     offset: offset,
        //     itemsPerPage: itemsPerPage
        // };
        // console.log(queryObject.filterValues);
        const body = {
            filterValues: queryObject.filterValues,
            offset: offset,
            itemsPerPage: itemsPerPage,
            query: queryObject.q,
            preLoadFilterValue: preLoadFilterValue
        }

        return fetch(url, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            headers: {'Content-type': 'application/json; charset=utf-8'},
            body: JSON.stringify(body),
            referrer: "no-referrer",
        })
        .then(response => {
            return response.json()
        })
        .catch(error => {console.log(error);return []});
    }

}
export default new DynamicSearchService();
